module.exports = __webpack_public_path__ + "static/media/FabDeliveryNewWhite.445ef21e.svg";